import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { styled } from 'twin.macro';

import { Flex } from '@ubisend/pulse-components';

import Bubble from './Bubble';

const StyledBubble = styled(Bubble)`
  padding: 0rem;
`;

const Location = ({ content, direction, ...props }) => {
  const { t } = useTranslation(['bots']);
  const { text, latitude, longitude } = content;

  const mapUrl =
    latitude && longitude
      ? `https://www.google.com/maps?q=${latitude},${longitude}&hl=es;z=14&output=embed`
      : null;

  const isReceived = direction === 'recievedMessage';

  return (
    <Flex fat right={isReceived}>
      {
        text
          ? (
            <Bubble direction={direction} {...props}>
              <span>{text}</span>
            </Bubble>
          )
          : (
            <StyledBubble direction={direction} {...props}>
              {
                mapUrl
                  ? (
                    <iframe
                      title={t('send_location_iframe_arial_label', { latitude, longitude })}
                      width="100%"
                      height="250"
                      style={{ border: 0 }}
                      src={mapUrl}
                      allowFullScreen
                    />
                  )
                  : (
                    <Flex col mt ySpaceSm fat>
                      <p>{t('send_location_not_available')}</p>
                    </Flex>
                  )
              }
            </StyledBubble>
          )
      }
    </Flex>
  );
};

Location.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }).isRequired,
  direction: Bubble.propTypes.direction,
};

export default Location;
